'use strict';

exports.__esModule = true;
exports.default = {
  SOCIAL: 'social',
  REVERSE_TIME: 'reverse_time',
  TIME: 'time'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-facebook/lib/constants/CommentsOrderBy.js
// module id = 753
// module chunks = 0